import React from 'react';

import { useTheme } from '@mui/material';

export const useScreenInfo = () => {
  const theme = useTheme();

  const screenWidth = React.useSyncExternalStore(subscribe, getClientWidth);
  const screenHeight = React.useSyncExternalStore(subscribe, getClientHeight);

  const isMobile = React.useMemo(
    () => screenWidth < theme.breakpoints.values.sm,
    [screenWidth, theme.breakpoints.values.sm],
  );

  React.useDebugValue(`Body size: ${screenWidth}x${screenHeight}px`);
  React.useDebugValue(isMobile ? 'Is Mobile' : 'Not Mobile');

  return {
    screenWidth,
    screenHeight,
    isMobile,
  };
};

const subscribe = (callback: () => void) => {
  window.addEventListener('resize', callback);
  return () => {
    window.removeEventListener('resize', callback);
  };
};

const getClientWidth = () => document.body.clientWidth;
const getClientHeight = () => document.body.clientHeight;
